import React from 'react';
import './form-stepper.css';

const FormStepper = ({ step }) => {
  const steps = [
    { label: 'Contact', animation: 'block', fontSize: '14px', fontWeight: '300', lineColor: 'rgba(150, 150, 150, 1)' },
    { label: 'Student', animation: 'block', fontSize: '14px', fontWeight: '300', lineColor: 'rgba(150, 150, 150, 1)' },
    { label: 'Availability', animation: 'block', fontSize: '14px', fontWeight: '300', lineColor: 'rgba(150, 150, 150, 1)' },
  ];

  return (
    <div className="form-stepper-wrapper">
      <div className="meter-wrapper" id="meter-wrapper">
        {steps.map((stepItem, index) => (
          <React.Fragment key={index}>
            <div className="the-dot" style={{ backgroundColor: step > index ? 'green' : 'rgba(150, 150, 150, 1)' }}>
              {step === index + 1 && <div className="the-animation" style={{ display: stepItem.animation }}></div>}
            </div>
            {index < steps.length - 1 && (
              <div
                className="the-line"
                style={{ backgroundColor: step > index + 1 ? 'green' : stepItem.lineColor }}
              ></div>
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="meter-label-wrapper" id="meter-label-wrapper">
        {steps.map((stepItem, index) => (
          <p
            className="meter-label"
            style={{
              fontSize: step === index + 1 ? '16px' : stepItem.fontSize,
              fontWeight: step >= index + 1 ? 'normal' : stepItem.fontWeight,
            }}
            key={index}
          >
            {stepItem.label}
          </p>
        ))}
      </div>
    </div>
  );
};

export default FormStepper;